<template>
    <div
        id="fale-conosco-banner"
        :style="{
            backgroundImage: `url(${isMobile ? bannerImage.mobile : bannerImage.desktop})`,
        }"
    >
        <h1 id="fale-conosco-title">Fale Conosco</h1>
    </div>
</template>

<script>
    export default {
        name: 'ContactUsBanner',
        props: {
            isMobile: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                bannerImage: {
                    mobile:
                        this.$scope.CDN_IMAGES +
                        '/images/hotsites/fale-conosco-v2/fale-conosco-chico-rei-mobile.png',
                    desktop:
                        this.$scope.CDN_IMAGES +
                        '/images/hotsites/fale-conosco-v2/fale-conosco-chico-rei.png',
                },
            };
        },
    };
</script>
